import { OnInit, Component, transition, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { FADE_IN_OUT_ANIMATION } from '@shared/animations';
import { Category, Language, FileRef } from '@shared/data';
import { CategoryQuery } from '@shared/queries';
import { LoadingService } from '@shared/modules/loading';

import { InputImageEvent } from '@shared/modules/input-image';
import { EditCategory } from './edit-category';

@Component({
  moduleId: 'module.id',
  selector: 'edit-category',
  styles: [require('./edit-category.component.scss')],
  template: require('./edit-category.component.html'),
  animations: [FADE_IN_OUT_ANIMATION]
})
export class EditCategoryComponent implements OnInit, OnDestroy {
  public category: Category;
  public parents: Category[];
  public error: Parse.Error;
  public isSaving: boolean;

  public categoryId: string;
  public hasParent: boolean;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private loadingService: LoadingService) {

    this.category = new Category();
    this.category.enabled = true;
  }

  public ngOnInit(): void {
    this.fetchParents();

    this.route.params.subscribe((params) => {
      this.categoryId = params['id'];
      this.parentId = params['parentId'];

      if (this.parentId) {
        this.hasParent = true;
      }

      if (!this.categoryId) {
        return;
      }

      this.fetchCategory();
    });
  }

  public ngOnDestroy(): void {
    this.category.revert();
  }

  // ===============================================================================================
  // Accessors
  // ===============================================================================================

  public get isValid() {
    return this.category.name;
  }

  public set parentId(parentId: string) {
    this.category.parent = parentId ? new Category(parentId) : null;
  }

  public get parentId(): string {
    return this.category.parent ? this.category.parent.id : '';
  }

  public get parentUrl(): string {
    return this.categoryId || this.hasParent ? '../../' : '../';
  }

  // ===============================================================================================
  // Actions
  // ===============================================================================================

  public onSave(): void {
    this.isSaving = true;
    this.loadingService.continue();

    this.category.save().then(
      (result) => {
        this.router.navigate([this.parentUrl], { relativeTo: this.route });
        this.isSaving = false;
      },
      (error: Parse.Error) => {
        this.error = error;
        this.isSaving = false;
        this.loadingService.complete();
      }
    );
  }

  public onImageChange(event: InputImageEvent): void {
    let image = this.category.image || new FileRef();

    image.setFile(event.file, event.data);
    this.category.image = image;
  }

  public onError(error) {
    this.error = error;
  }

  // ===============================================================================================
  // Private Methods
  // ===============================================================================================

  private fetchCategory(): void {
    let query = new CategoryQuery()
      .include(Category.IMAGE_KEY)
      .include(Category.PARENT_KEY);

    this.loadingService.continue();

    query.equalTo(Category.OBJECT_ID_KEY, this.categoryId).first().then(
      (result: Category) => {
        this.category = result;
        this.loadingService.complete();
      },
      (error: Parse.Error) => {
        this.error = error;
        this.loadingService.complete();
      }
    );
  }

  private fetchParents(): void  {
    let query = new CategoryQuery()
      .doesNotExist(Category.PARENT_KEY);

    this.loadingService.continue();

    query.find().then(
      (result: Category[]) => {
        this.parents = result;
        this.loadingService.complete();
      },
      (error) => {
        this.error = error;
        this.loadingService.complete();
      }
    );
  }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/+admin/modules/+category/edit-category/edit-category.component.ts